// csgo品质
const shopQuality = [{
		val: 1,
		text: '消费级'
	},
	{
		val: 2,
		text: '军规级'
	},
	{
		val: 3,
		text: '工业级'
	},
	{
		val: 4,
		text: '受限'
	},
	{
		val: 5,
		text: '保密'
	},
	{
		val: 6,
		text: '隐秘'
	},
	{
		val: 7,
		text: '普通级'
	},
	{
		val: 8,
		text: '高级'
	},
	{
		val: 9,
		text: '非凡'
	},
	{
		val: 10,
		text: '奇异'
	},
	{
		val: 11,
		text: '卓越'
	},
	{
		val: 12,
		text: '违禁'
	},
	{
		val: 13,
		text: '探员-高级'
	},
	{
		val: 14,
		text: '探员-卓越'
	},
	{
		val: 15,
		text: '探员-非凡'
	},
	{
		val: 16,
		text: '探员-大师'
	}
]
export default shopQuality
